module.exports = {
  btn: require('./src/components/btn/btn.vue'),
  chips: require('./src/components/chips/chips.vue'),
  chipsInput: require('./src/components/chips-input/chips-input.vue'),
  icon: require('./src/components/icon/icon.vue'),
  iconBtn: require('./src/components/icon-btn/icon-btn.vue'),
  textField: require('./src/components/text-field/text-field.vue'),
  baseStyles: require('./src/universal/base.scss'),
  varStyles: require('./src/universal/vars.scss')
}
